// extracted by mini-css-extract-plugin
export default {"container":"CreateIndexDialog-module__container--DHhDA","header":"CreateIndexDialog-module__header--Z5S8Z","headerSubtext":"CreateIndexDialog-module__headerSubtext--Rei36"};